(function (Drupal, once) {

  let webchatLoaded = false;

  function loadWebChat() {
    if (webchatLoaded) return;
    webchatLoaded = true;

    const script = document.createElement('script');
    script.src = 'https://cdn.botframework.com/botframework-webchat/latest/webchat.js';
    script.async = true;

    script.onload = function () {
      if (window.initWebChat) {
        window.initWebChat();
      } else {
        console.error('initWebChat not found');
      }
    };

    document.body.appendChild(script);
  }

  Drupal.behaviors.aiWebchatLoader = {
    attach(context) {
      once('ai-webchat-loader', '#chatbotOpen', context).forEach(button => {
        button.addEventListener('click', loadWebChat);
      });
    }
  };

})(Drupal, once);
